(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.AddGrowerTreatmentController = (function(superClass) {
    extend(AddGrowerTreatmentController, superClass);

    function AddGrowerTreatmentController(scope, $transitions, modalInstance, http, autoSelect) {
      this.scope = scope;
      this.modalInstance = modalInstance;
      this.http = http;
      this.save = bind(this.save, this);
      AddGrowerTreatmentController.__super__.constructor.call(this, this.scope, $transitions, this.modalInstance);
      this.scope.title = 'Add Treatment';
      this.scope.treatment = {
        name: '',
        crop: null
      };
      this.scope.crops = [];
      this.http.get('backend/core/crops').then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(crops) {
          _this.scope.crops = crops;
          if ((autoSelect != null ? autoSelect.crop : void 0) != null) {
            return _this.scope.treatment.crop = crops.find(function(crop) {
              return crop.id === autoSelect.crop;
            });
          }
        };
      })(this));
    }

    AddGrowerTreatmentController.prototype.save = function(pretend) {
      return this.http.post('backend/grower/treatments', this.scope.treatment).then((function(_this) {
        return function(response) {
          if (!pretend) {
            return _this.modalInstance.close(response.data);
          }
        };
      })(this));
    };

    return AddGrowerTreatmentController;

  })(DialogController);

}).call(this);
